import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Modal,
  Select,
  DatePicker,
  DateRangeFields,
  GET,
  POST,
  alert,
  t,
  format_date,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { can } from "../../utils/permission";
import { formatNumber } from "../../utils/formatting";

// PO รอรับสินค้า = Awaiting Receipt และ Partial
const RECEIVABLE_PO_STATUS = ["awaiting_receipt", "partial"];
// สีส้มเดียวกับปุ่มรับบางส่วน
const ORANGE = "#f59e0b";

// จำนวนรายการใน PO ที่รับครบแล้ว
const receivedCount = (po) =>
  (po.items || []).filter((it) => Number(it.received_qty || 0) >= Number(it.quantity || 0)).length;

export default class GoodsReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Data from API
      // -----------------------------------
      filter_po_from: "", // ตัวกรองวันที่ PO รอรับ (po_date = วันที่สั่งซื้อ)
      filter_po_to: "",
      filter_gr_from: "", // ตัวกรองวันที่ใบรับ (gr_date = วันที่รับ)
      filter_gr_to: "",
      po_waiting: [], // PO ที่รอรับสินค้า (มาจาก warehouse/purchase-orders)
      grn_history: [], // ใบรับล่าสุด (มาจาก warehouse/goods-receipts)
      data_warehouses: [], // dropdown คลังปลายทาง
      data_locations: [], // dropdown พื้นที่เก็บ

      summary: {
        waiting_receive: 0,
        due_today: 0,
        missed: 0,
        received_this_month: 0,
      },

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_receive: false,
      active_po: null, // PO ที่กำลังถูกกดรับสินค้า

      // Form States (for Receive Modal)
      form_warehouse_id: "",
      form_delivery_no: "",
      form_invoice_no: "",
      form_invoice_date: "",
      form_note: "",

      // Items in Modal (ดึงมาจาก PO ที่เลือก) - แก้ไขได้
      form_receive_items: [],
    };
  }

  async componentDidMount() {
    this.Get();
  }

  formatNumber = (num) => {
    return Number(num || 0).toLocaleString();
  };

  // -----------------------------------------------------------------
  // โหลดข้อมูลทั้งหมดของหน้า
  // -----------------------------------------------------------------
  Get = async () => {
    const { filter_po_from, filter_po_to, filter_gr_from, filter_gr_to } = this.state;
    if ((filter_po_from && filter_po_to && filter_po_from > filter_po_to) || (filter_gr_from && filter_gr_to && filter_gr_from > filter_gr_to)) {
      alert("", "warning", t("warning"), t("nsp_range_invalid"));
      return;
    }
    loading(true);
    const [resPO, resGR, resWarehouse] = await Promise.all([
      GET("warehouse/purchase-orders", { page_size: 10000, page: 0, from_date: filter_po_from || "", to_date: filter_po_to || "" }),
      GET("warehouse/goods-receipts", { page_size: 10000, page: 0, from_date: filter_gr_from || "", to_date: filter_gr_to || "" }),
      GET("warehouse/warehouses", { page_size: 10000, page: 0 }), // scope ตาม company ที่ backend อยู่แล้ว
    ]);

    // ---- PO รอรับ ----
    let po_waiting = [];
    if (resPO?.status) {
      po_waiting = (resPO.data || []).filter((po) => {
        const status = (po.status || "").toLowerCase();
        if (!RECEIVABLE_PO_STATUS.includes(status)) return false;
        // ยังรับไม่ครบ: มีอย่างน้อย 1 รายการที่ received_qty < quantity
        const items = po.items || [];
        if (!items.length) return true;
        return items.some(
          (it) => Number(it.received_qty || 0) < Number(it.quantity || 0)
        );
      });
    }

    // ---- ใบรับล่าสุด ----
    let grn_history = [];
    if (resGR?.status) {
      grn_history = resGR.data || [];
    }

    // ---- dropdown คลัง (เก็บ locations ของแต่ละคลังไว้ใน option ด้วย) ----
    let data_warehouses = [];
    if (resWarehouse?.status) {
      data_warehouses = (resWarehouse.data || []).map((w) => ({
        ...w,
        value: w.uid,
        label: w.name,
      }));
    }

    this.setState({
      po_waiting,
      grn_history,
      data_warehouses,
      summary: this.buildSummary(po_waiting, grn_history),
    });

    loading(false);
  };

  // map locations ของคลังที่เลือก ให้เป็น options ของ Select
  mapLocations = (warehouse) =>
    (warehouse?.locations || []).map((l) => ({ value: l.uid, label: l.name }));

  // -----------------------------------------------------------------
  // คำนวณตัวเลขการ์ดด้านบนจากข้อมูลจริง
  // -----------------------------------------------------------------
  buildSummary = (poList, grList) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    let due_today = 0;
    let missed = 0;
    poList.forEach((po) => {
      if (!po.due_date) return;
      const d = new Date(po.due_date);
      d.setHours(0, 0, 0, 0);
      if (d.getTime() === today.getTime()) due_today += 1;
      else if (d.getTime() < today.getTime()) missed += 1;
    });

    const received_this_month = grList.filter((gr) => {
      if (!gr.gr_date) return false;
      return new Date(gr.gr_date) >= startOfMonth;
    }).length;

    return {
      waiting_receive: poList.length,
      due_today,
      missed,
      received_this_month,
    };
  };

  // คืนสีของวันที่กำหนดส่ง เทียบกับวันนี้
  getExpectedColor = (deliveryDate) => {
    if (!deliveryDate) return "primary";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const d = new Date(deliveryDate);
    d.setHours(0, 0, 0, 0);
    if (d.getTime() < today.getTime()) return "danger";
    if (d.getTime() === today.getTime()) return "warning";
    return "primary";
  };

  getStatusLabel = (deliveryDate) => {
    const color = this.getExpectedColor(deliveryDate);
    if (color === "danger") return { text: t("overdue"), color };
    if (color === "warning") return { text: t("due_today"), color };
    return { text: t("on_schedule"), color };
  };

  // -----------------------------------------------------------------
  // เปิด modal รับสินค้า: แสดงทุกรายการของ PO - รายการที่รับครบแล้วแสดงไว้แต่ปิดการแก้ไข
  // -----------------------------------------------------------------
  openReceiveModal = (po) => {
    const items = (po.items || [])
      .map((it) => {
        const ordered = Number(it.quantity || 0);
        const receivedPrev = Number(it.received_qty || 0);
        const remaining = Math.max(ordered - receivedPrev, 0);
        return {
          po_item_uid: it.uid || "",
          part_uid: it.part?.uid || "",
          part_code: it.part?.part_number || "",
          desc: it.part?.name || "",
          uom_name: it.uom_name || it.unit || "",
          ordered,
          received_prev: receivedPrev,
          remaining,
          receive_now: remaining,
          fully_received: remaining <= 0,
          unit_cost: Number(it.unit_cost || 0),
          batch: "",
          location_id: "",
        };
      });

    const defaultWh = this.state.data_warehouses[0] || null;

    this.setState({
      modal_receive: true,
      active_po: po,
      form_receive_items: items,
      form_warehouse_id: defaultWh?.value || "",
      data_locations: this.mapLocations(defaultWh),
      form_delivery_no: "",
      form_invoice_no: "",
      form_invoice_date: "",
      form_note: "",
    });
  };

  // เปลี่ยนคลัง -> โหลด location ของคลังนั้น และล้าง location ที่เลือกไว้ในทุกแถว
  onChangeWarehouse = (value) => {
    const wh = this.state.data_warehouses.find((w) => w.value === value);
    const items = this.state.form_receive_items.map((it) => ({ ...it, location_id: "" }));
    this.setState({
      form_warehouse_id: value,
      data_locations: this.mapLocations(wh),
      form_receive_items: items,
    });
  };

  updateItem = (idx, field, value) => {
    const items = [...this.state.form_receive_items];
    // "รับครั้งนี้" ต้องไม่เกินจำนวนคงเหลือที่สั่งซื้อ (remaining = ordered - received_prev)
    if (field === "receive_now") {
      const max = Number(items[idx].remaining || 0);
      let num = Number(value);
      if (Number.isNaN(num) || num < 0) num = 0;
      if (num > max) num = max;
      value = num;
    }
    items[idx] = { ...items[idx], [field]: value };
    // ไม่รับรายการนี้ (0) = ช่อง Lot/Batch และตำแหน่งถูกปิด ล้างค่าที่กรอกค้างไว้ด้วย
    if (field === "receive_now" && value === 0) {
      items[idx] = { ...items[idx], batch: "", location_id: "" };
    }
    this.setState({ form_receive_items: items });
  };

  // รับครั้งนี้แล้วจะครบทุกรายการของ PO ไหม -> ใช้ตั้งชื่อ/สีปุ่ม (รับครบ / รับบางส่วน)
  isFullReceipt = (items) =>
    items.length > 0 && items.every((it) => it.received_prev + Number(it.receive_now || 0) >= it.ordered);

  // -----------------------------------------------------------------
  // รับสินค้าตามจำนวน "รับครั้งนี้" ของแต่ละรายการ (ปุ่มเดียว ชื่อเปลี่ยนตาม isFullReceipt)
  // -----------------------------------------------------------------
  doReceive = async () => {
    const {
      active_po,
      form_receive_items,
      form_warehouse_id,
      form_delivery_no,
      form_invoice_no,
      form_invoice_date,
      form_note,
    } = this.state;

    if (!active_po?.supplier?.uid) {
      alert("", "warning", t("warning"), t("supplier_not_found"));
      return;
    }
    if (!form_warehouse_id) {
      alert("", "warning", t("warning"), t("select_warehouse"));
      return;
    }

    const items = form_receive_items
      .map((it) => ({
        part_id: it.part_uid,
        po_item_id: it.po_item_uid || "",
        quantity: Number(it.receive_now) || 0,
        unit_cost: Number(it.unit_cost) || 0,
        batch_number: it.batch || "",
        location_id: it.location_id || "",
      }))
      .filter((it) => it.part_id && it.quantity > 0);

    if (!items.length) {
      alert("", "warning", t("warning"), t("no_qty_to_receive"));
      return;
    }

    if (
      !(await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel")
      ))
    ) {
      return;
    }

    loading(true);
    const body = {
      po_id: active_po?.uid || "",
      supplier_id: active_po.supplier.uid,
      warehouse_id: form_warehouse_id,
      invoice_number: form_invoice_no || "",
      invoice_date: form_invoice_date || null,
      delivery_note: form_delivery_no || "",
      notes: form_note || "",
      items,
    };

    // สร้างใบรับ + ตัดเข้าสต๊อก + อัปเดต PO ใน transaction เดียวฝั่ง backend
    // error = rollback ทั้งหมด ไม่มีใบรับ/สต๊อก/lot/movement ถูกบันทึก - แก้แล้วกดรับใหม่ได้เลย
    const result = await POST("warehouse/goods-receipts/receive", body);
    if (result?.status === true) {
      alert("#", "success");
      this.setState({ modal_receive: false });
      this.Get();
    } else {
      alert("", "warning", t("warning"), result?.message || t("gr_stock_post_failed"));
    }
    loading(false);
  };

  render() {
    const {
      summary,
      po_waiting,
      grn_history,
      data_warehouses,
      data_locations,
      modal_receive,
      active_po,
      form_receive_items,
      form_warehouse_id,
      form_delivery_no,
      form_invoice_no,
      form_invoice_date,
      form_note,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("receive_goods")}</h3>
                    <div className="text-secondary text-14">{t("receive_from_po")}</div>
                </div>

                {/* Top Stats Cards (4 Columns) */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.waiting_receive)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("waiting_receive")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.due_today)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("due_today")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                                <div>
                                    <h3 className="fw-bold text-danger mb-0">{this.formatNumber(summary.missed)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("overdue")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.received_this_month)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("received_this_month")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 1: PO รอรับสินค้า */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
                        <span className="icon text-purple me-2">{""}</span> {t("po_waiting_list")}
                    </h6>
                    <div className="d-flex gap-2 mb-3 align-items-center" style={{ maxWidth: 480 }} data-testid="po-date-filter">
                        <DateRangeFields
                            type="th"
                            className="form-control"
                            fieldStyle={{ flex: 1, minWidth: 0 }}
                            startPlaceholder={t("start_date")}
                            endPlaceholder={t("end_date")}
                            startValue={this.state.filter_po_from}
                            endValue={this.state.filter_po_to}
                            onChange={({ start, end }) => this.setState({ filter_po_from: start, filter_po_to: end }, () => this.Get())}
                        />
                        {(this.state.filter_po_from || this.state.filter_po_to) && (
                            <button type="button" className="btn btn-white border px-3 py-2 fw-bold rounded-3 text-nowrap" onClick={() => this.setState({ filter_po_from: "", filter_po_to: "" }, () => this.Get())}>
                                {t("clear_all")}
                            </button>
                        )}
                    </div>
                    <div className="table-responsive">
                        <table className="table align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-2 border-0 wpx-150">{t("po_number")}</th>
                                    <th className="py-3 border-0 wpx-200">{t("supplier")}</th>
                                    <th className="py-3 border-0 text-center wpx-150">{t("order_date")}</th>
                                    <th className="py-3 border-0 text-center wpx-150">{t("expected_date")}</th>
                                    <th className="py-3 border-0 text-center text-nowrap wpx-120">{t("items")} / {t("gr_received_prev")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("total_amount")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-140">{t("manage")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {po_waiting.length === 0 && (
                                    <tr>
                                        <td colSpan={8} className="text-center text-secondary py-4">
                                            {t("no_data")}
                                        </td>
                                    </tr>
                                )}
                                {po_waiting.map((po, idx) => {
                                    const expectedColor = this.getExpectedColor(po.due_date);
                                    const statusInfo = this.getStatusLabel(po.due_date);
                                    return (
                                        <tr
                                            key={po.uid || idx}
                                            className={`border-bottom border-light ${expectedColor === "danger" ? "bg-danger-light" : expectedColor === "warning" ? "bg-warning-light" : "bg-white"}`}
                                        >
                                            <td className="py-3 px-2">
                                                <span className="fw-bold text-primary text-14">{po.po_number}</span>
                                            </td>
                                            <td className="text-dark text-14">
                                                <span className="text-truncate d-inline-block align-middle" style={{ maxWidth: 180 }} title={po.supplier?.name || ""}>
                                                    {po.supplier?.name || "-"}
                                                </span>
                                            </td>
                                            <td className="text-center text-secondary text-14">{po.po_date ? format_date(po.po_date) : "-"}</td>
                                            <td className="text-center">
                                                <span className={`fw-bold text-14 text-${expectedColor}`}>{po.due_date ? format_date(po.due_date) : "-"}</span>
                                            </td>
                                            <td className="text-center fw-bold text-dark text-14 text-nowrap">
                                                {/* รับแล้ว = รายการที่รับครบแล้ว - ยังไม่ครบทุกรายการแสดงสีส้ม */}
                                                {formatNumber(po.items?.length || 0)} /{" "}
                                                <span style={receivedCount(po) < (po.items?.length || 0) ? { color: ORANGE } : undefined}>{formatNumber(receivedCount(po))}</span>
                                            </td>
                                            <td className="text-center fw-bold text-dark text-14">{this.formatNumber(po.total_amount)}</td>
                                            <td className="text-center">
                                                <span
                                                    className={`badge bg-${statusInfo.color}-light text-${statusInfo.color} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusInfo.color}`}
                                                >
                                                    {statusInfo.text}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                {can("gr.create") && can("gr.update") && (
                                                    <button
                                                        className="btn btn-success btn-sm px-3 py-1 fw-bold rounded-2 shadow-sm d-flex align-items-center justify-content-center mx-auto"
                                                        style={{ backgroundColor: "#22c55e", borderColor: "#22c55e" }}
                                                        onClick={() => this.openReceiveModal(po)}
                                                    >
                                                        <span className="icon me-1">{""}</span> {t("btn_receive")}
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Section 2: ใบรับสินค้าล่าสุด (GRN) */}
                <div className="bg-white rounded-4 shadow-sm p-4 pb-2">
                    <h6 className="fw-bold text-dark mb-3 d-flex align-items-center">
                        <span className="icon text-success me-2">{""}</span> {t("recent_grn")}
                    </h6>
                    <div className="d-flex gap-2 mb-3 align-items-center" style={{ maxWidth: 480 }} data-testid="gr-date-filter">
                        <DateRangeFields
                            type="th"
                            className="form-control"
                            fieldStyle={{ flex: 1, minWidth: 0 }}
                            startPlaceholder={t("start_date")}
                            endPlaceholder={t("end_date")}
                            startValue={this.state.filter_gr_from}
                            endValue={this.state.filter_gr_to}
                            onChange={({ start, end }) => this.setState({ filter_gr_from: start, filter_gr_to: end }, () => this.Get())}
                        />
                        {(this.state.filter_gr_from || this.state.filter_gr_to) && (
                            <button type="button" className="btn btn-white border px-3 py-2 fw-bold rounded-3 text-nowrap" onClick={() => this.setState({ filter_gr_from: "", filter_gr_to: "" }, () => this.Get())}>
                                {t("clear_all")}
                            </button>
                        )}
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-2 border-0 wpx-150">{t("grn_number")}</th>
                                    <th className="py-3 border-0 wpx-150">{t("ref_po")}</th>
                                    <th className="py-3 border-0 wpx-200">{t("supplier")}</th>
                                    <th className="py-3 border-0 text-center wpx-150">{t("received_date")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("items")}</th>
                                    <th className="py-3 border-0 text-center wpx-120">{t("receiver")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {grn_history.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="text-center text-secondary py-4">
                                            {t("no_data")}
                                        </td>
                                    </tr>
                                )}
                                {grn_history.slice(0, 10).map((gr, idx) => {
                                    const statusColor = gr.status === "completed" ? "success" : gr.status === "cancelled" ? "danger" : "warning";
                                    return (
                                        <tr key={gr.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="py-3 px-2">
                                                <span className="fw-bold text-primary text-14">{gr.gr_number}</span>
                                            </td>
                                            <td className="text-secondary text-14">{gr.purchase_order?.po_number || "-"}</td>
                                            <td className="text-dark text-14">
                                                <span className="text-truncate d-inline-block align-middle" style={{ maxWidth: 180 }} title={gr.supplier?.name || ""}>
                                                    {gr.supplier?.name || "-"}
                                                </span>
                                            </td>
                                            <td className="text-center text-secondary text-14">{gr.gr_date ? format_date(gr.gr_date) : "-"}</td>
                                            <td className="text-center fw-bold text-dark text-14">{formatNumber(gr.items?.length || 0)}</td>
                                            <td className="text-center text-dark text-14">{gr.receiver?.name || "-"}</td>
                                            <td className="text-center">
                                                <span className={`badge bg-${statusColor}-light text-${statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusColor}`}>
                                                    {t(`gr_status_${gr.status}`) !== `gr_status_${gr.status}` ? t(`gr_status_${gr.status}`) : gr.status}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal size="xl" show={modal_receive} onHide={() => this.setState({ modal_receive: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">
                        {t("modal_receive_title")} - {active_po?.po_number}
                    </h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row mb-4">
                        <div className="col-md-3">
                            <div className="text-secondary text-12 mb-1">{t("supplier")}</div>
                            <div className="fw-bold text-dark text-16">{active_po?.supplier?.name || "-"}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-secondary text-12 mb-1">{t("order_date")}</div>
                            <div className="fw-bold text-dark text-16">{active_po?.po_date ? format_date(active_po.po_date) : "-"}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-secondary text-12 mb-1">{t("expected_date")}</div>
                            <div className={`fw-bold text-16 text-${this.getExpectedColor(active_po?.due_date)}`}>{active_po?.due_date ? format_date(active_po.due_date) : "-"}</div>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label text-12 text-secondary mb-1">{t("warehouse")} *</label>
                            <Select
                                className="form-control w-100"
                                options={data_warehouses}
                                value={form_warehouse_id}
                                onChange={(e) => this.onChangeWarehouse(e)}
                                placeholder={t("select_warehouse")}
                            />
                        </div>
                    </div>

                    <div className="mb-4">
                        <h6 className="fw-bold text-dark mb-3">{t("items_to_receive")}</h6>
                        <div className="table-responsive bg-light p-2 rounded-3 border border-light">
                            <table className="table align-middle mb-0 border-0">
                                <thead>
                                    <tr className="text-dark fw-bold text-12">
                                        {/* หัวตารางบรรทัดเดียวทุกช่อง - คอลัมน์จำนวนกว้างตามหัวข้อ (ไม่ล็อก wpx) ส่วนที่เหลือให้คำอธิบาย */}
                                        <th className="py-2 border-0 bg-transparent text-nowrap wpx-100">{t("part_code")}</th>
                                        <th className="py-2 border-0 bg-transparent text-nowrap">{t("description")}</th>
                                        <th className="py-2 border-0 bg-transparent text-center text-nowrap">{t("ordered_qty")}</th>
                                        <th className="py-2 border-0 bg-transparent text-center text-nowrap">{t("gr_received_prev")}</th>
                                        <th className="py-2 border-0 bg-transparent text-center text-nowrap">{t("receive_now")}</th>
                                        <th className="py-2 border-0 bg-transparent text-center text-nowrap wpx-160">{t("lot_batch")}</th>
                                        <th className="py-2 border-0 bg-transparent text-nowrap wpx-200">{t("location")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {form_receive_items.length === 0 && (
                                        <tr>
                                            <td colSpan={7} className="text-center text-secondary py-3 bg-transparent">
                                                {t("no_data")}
                                            </td>
                                        </tr>
                                    )}
                                    {form_receive_items.map((item, idx) => (
                                        <tr
                                            key={idx}
                                            className="bg-transparent border-bottom border-white"
                                            // รับครบแล้ว: แสดงไว้ให้เห็นทั้ง PO แต่จางและแก้ไม่ได้
                                            style={item.fully_received ? { opacity: 0.5 } : undefined}
                                            title={item.fully_received ? t("gr_fully_received") : undefined}
                                        >
                                            <td className="py-2 px-1">
                                                {/* รหัสยาวเกินช่อง (wpx-100) ตัดเป็น ... ไม่ขึ้นบรรทัดใหม่ (ชี้ดูเต็มได้) */}
                                                <div className="fw-bold text-primary text-12 text-truncate" style={{ maxWidth: 100 }} title={item.part_code}>
                                                    {item.part_code}
                                                </div>
                                            </td>
                                            {/* 1 บรรทัด กินพื้นที่ที่เหลือทั้งหมดจนถึงคอลัมน์สั่งซื้อ ยาวเกินตัดเป็น ... (ชี้ดูเต็มได้)
                                                width 100% + maxWidth 0 ให้ช่องขยายเต็มแต่ไม่ดันตาราง - คอลัมน์อื่นล็อกความกว้างด้วย wpx-* */}
                                            <td className="py-2 text-dark text-12 px-1" style={{ width: "100%", maxWidth: 0 }}>
                                                <div className="text-truncate" title={item.desc}>
                                                    {item.desc}
                                                </div>
                                            </td>
                                            {/* จำนวนรองรับหลักร้อยพร้อมทศนิยม (เช่น 999.99) โดยคอลัมน์ไม่ขยับตามค่า */}
                                            <td className="py-2 text-center text-dark text-14 px-1 text-nowrap" style={{ minWidth: 80 }}>{formatNumber(item.ordered)}</td>
                                            <td className="py-2 text-center text-secondary text-14 px-1 text-nowrap" style={{ minWidth: 80 }}>{formatNumber(item.received_prev)}</td>
                                            <td className="py-2 px-1">
                                                <input
                                                    type="number"
                                                    min="0"
                                                    style={{ height: 35, width: 90 }}
                                                    max={item.remaining}
                                                    className={`form-control form-control-sm text-center rounded-2 text-dark border shadow-none mx-auto ${item.fully_received ? "" : "bg-white"}`}
                                                    value={item.receive_now}
                                                    disabled={item.fully_received}
                                                    onChange={(e) => this.updateItem(idx, "receive_now", e.target.value)}
                                                />
                                            </td>
                                            <td className="py-2 px-1">
                                                <input
                                                    type="text"
                                                    style={{ height: 35 }}
                                                    className={`form-control form-control-sm rounded-2 text-secondary border shadow-none ${Number(item.receive_now) > 0 ? "bg-white" : ""}`}
                                                    placeholder={t("lot_batch")}
                                                    disabled={!(Number(item.receive_now) > 0)}
                                                    value={item.batch}
                                                    onChange={(e) => this.updateItem(idx, "batch", e.target.value)}
                                                />
                                            </td>
                                            <td className="py-2 px-1" style={{ minWidth: 200 }}>
                                                <Select
                                                    className="form-control w-100"
                                                    options={data_locations}
                                                    value={item.location_id}
                                                    disabled={!(Number(item.receive_now) > 0)}
                                                    onChange={(e) => this.updateItem(idx, "location_id", e)}
                                                    placeholder={t("location")}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row g-4 mb-4">
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("delivery_note_no")}</label>
                            <input
                                type="text"
                                className="form-control py-2 shadow-none"
                                placeholder={t("delivery_note_no")}
                                value={form_delivery_no}
                                onChange={(e) => this.setState({ form_delivery_no: e.target.value })}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("invoice_no")}</label>
                            <input
                                type="text"
                                className="form-control py-2 shadow-none"
                                placeholder={t("invoice_no")}
                                value={form_invoice_no}
                                onChange={(e) => this.setState({ form_invoice_no: e.target.value })}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("invoice_date")}</label>
                            <DatePicker
                                type="th"
                                className="form-control py-2 text-dark"
                                value={form_invoice_date ? form_invoice_date.split("T")[0] : ""}
                                onChange={(val) => this.setState({ form_invoice_date: val })}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="form-label text-14 text-dark fw-bold mb-2">{t("note")}</label>
                        <textarea className="form-control py-2" rows="3" placeholder={t("note")} value={form_note} onChange={(e) => this.setState({ form_note: e.target.value })}></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_receive: false })}>
                        {t("cancel")}
                    </button>
                    {/* ปุ่มเดียว: รับครั้งนี้แล้วครบทุกรายการ = "รับครบ" (เขียว) ไม่ครบ = "รับบางส่วน" (ส้ม) */}
                    {this.isFullReceipt(form_receive_items) ? (
                        <button
                            className="btn btn-success px-4 py-2 rounded-3 fw-bold text-white shadow-sm"
                            style={{ backgroundColor: "#22c55e", borderColor: "#22c55e" }}
                            onClick={this.doReceive}
                        >
                            {t("btn_receive_full")}
                        </button>
                    ) : (
                        <button
                            className="btn btn-warning px-4 py-2 rounded-3 fw-bold text-white shadow-sm"
                            style={{ backgroundColor: ORANGE, borderColor: ORANGE }}
                            onClick={this.doReceive}
                        >
                            {t("btn_receive_partial")}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
